export default __webpack_public_path__ + "static/media/bitcoin-1.5fec94fa.svg";